export const INITIAL_VALUES = {
  customerNewName: "",
  document: "",
  phone: "",
  date: "",
  time: {},
  protocol: "",
  protocolNumbers: [],
  rescheduleDate: null
}

export const TEXT_ACTION = {
  "Reagendar portabilidade": {
    title: "do reagendamento",
    button: "e reagendar",
    label: "reagendar"
  },
  "Suspender portabilidade": {
    title: "da suspensão",
    button: "e suspender",
    label: "suspender"
  },
  "Cancelar portabilidade": {
    title: "do cancelamento",
    button: "e cancelar",
    label: "cancelar"
  },
  "Exportar dados do cliente": {
    title: "de exportação",
    button: "e exportar",
    type: "ASSET"
  },
  "Exportar números": {
    title: "de exportação",
    button: "e exportar",
    type: "ASSET_DETAILS"
  },
  "Exportar protocolos": {
    title: "de exportação",
    button: "e exportar",
    type: "ORDERS_DETAILS"
  }
}

export const WARNING_TEXT_ACTION = {
  "Editar cliente": "Erro ao tentar editar cliente. Descrição: 'ERROR'",
  "Reagendar portabilidade":
    "Erro ao tentar reagendar portabilidade. Descrição: 'ERROR'",
  "Suspender portabilidade":
    "Erro ao tentar suspender portabilidade. Descrição: 'ERROR'",
  "Cancelar portabilidade":
    "Erro ao tentar cancelar portabilidade. Descrição: 'ERROR'"
}

export const WARNING_TEXT_STATUS = {
  INTERROMPIDO: "O número informado possui status de interrompido.",
  NOVO: "O número informado não é um número portado.",
  NOT_FOUND: "Não encontrado clientes com esse número"
}

export const EXPORT_DATA = [
  "Exportar números",
  "Exportar protocolos",
  "Exportar dados do cliente"
]



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/constants.js